export default __webpack_public_path__ + "static/FiraMono-Regular-58ea07e7d3f4e51e98eddf555ca4a531.woff";